import { useAtomValue } from 'jotai';
import React from 'react';
import { videoSelectedForAlignmentCheckAtom } from '../../../atoms/videoAlignmentRequired';
import { ReviewOffsets } from '../ReviewOffsets';

export function ReviewOffsetsStep() {
  const videoSelectedForAlignmentCheck = useAtomValue(
    videoSelectedForAlignmentCheckAtom,
  );
  const { videoInfo, videoReference } = videoSelectedForAlignmentCheck || {};

  if (!videoSelectedForAlignmentCheck) return null;

  return (
    <ReviewOffsets videoInfo={videoInfo} videoReference={videoReference} />
  );
}

export default ReviewOffsetsStep;
